<template>
  <div>
    <header>
      <img src="../assets/img/illustrations/bgWild.jpg" class="banner" alt="">
      

      <div class="container">
        <div class="row">
            <div class="col-lg-6">
              <h1>AgriVitech devient Akanea Reims</h1>
              <h2>Nous sommes fiers de vous annoncer qu'AgriVitech a été rachetée par la société <a href="https://akanea.com/" class="green" target="_blank">Akanea Développement</a> du <a href="https://www.isagri.com/" class="green"  target="_blank">Groupe Isagri</a>. Toute l'équipe est fière de cette nouvelle étape qui portera la solution Fleet aux plus grands acteurs du monde du transport.</h2>
              <a href="https://akanea.com/integration-fleet-by-agrivitech/" target="_blank" class="btn mt-3" style="background-color: var(--mainGreen); color: white;">Lire le communiqué de presse</a>
            </div>
            <div class="col">
              <img src="../assets/img/illustrations/agri.jpg" class="bannerImg" alt="Echanges Agris">
              <img src="../assets/img/illustrations/fleetTB.jpg" class="bannerImg" alt="Fleet">
            </div>
           
            <div class="col">
              <img src="../assets/img/illustrations/dapApp.jpg" class="bannerImg max90" alt="NovAppro">
            </div>
             
        </div>
      </div>

  
  </header>

  <div class="container text-center">
    <div class="title">{{ $t('solutions.titleClients[0]') }} <span class="green">{{ $t('solutions.titleClients[1]') }} </span> {{ $t('solutions.titleClients[2]') }}  <span class="green">{{ $t('solutions.titleClients[3]') }} </span> {{ $t('solutions.titleClients[4]') }} </div>

    <div class="row clients-logo">
      <div class="col-lg-3 logoContainer"><img src="../assets/img/cooperl.png" class="logoClient" alt="Cooperl"></div>
      <div class="col-lg-3 logoContainer"><img src="../assets/img/ceresia.png" class="logoClient" alt="Ceresia"></div>
      <div class="col-lg-3 logoContainer"><img src="../assets/img/vivescia.png" class="logoClient" alt="Vivescia"></div>
      <div class="col-lg-3 logoContainer"><img src="../assets/img/seveal.png" class="logoClient" alt="Seveal"></div>
      <div class="col-lg-3 logoContainer"><img src="@/assets/img/logo_novagrain.svg" class="logoClient" alt="Logo Novagrain"></div>
      <div class="col-lg-3 logoContainer"><img src="../assets/img/acolyance.png" class="logoClient" alt="Acolyance"></div>
      <div class="col-lg-3 logoContainer"><img src="../assets/img/prestalyance.png" class="logoClient" alt="Prestalyance"></div>
      <div class="col-lg-3 logoContainer"><img src="../assets/img/logo-sepac-compagri.jpg" class="logoClient" alt="Sepac Compagri"></div>
      <div class="col-lg-3 logoContainer"><img src="../assets/img/logo_capvert.jpg" class="logoClient" alt="Logo Cap Vert"></div>
      <div class="col-lg-3 logoContainer"><img src="../assets/img/logo_talian.jpg" class="logoClient" alt="Logo Talian"></div>
    </div>

  </div>
  

  <div class="container text-center">
        

    

    <div class="title pb-0" >{{ $t('solutions.fleet.title[0]') }}  <span class="green">{{ $t('fleet') }}</span> {{ $t('solutions.fleet.title[1]') }}</div>
    <div class="subTitled">{{ $t('solutions.fleet.subTitle') }}</div>

    <div class="row solution-preview">
      <div class="col-sm-12 col-md-6 light-block">
         <div class="title-block"><strong>{{ $t('solutions.fleet.sectionBackOffice.title') }}</strong> <br>{{ $t('solutions.fleet.sectionBackOffice.subTitle') }}</div>
        <div> {{ $t('solutions.fleet.sectionBackOffice.content') }} <strong>{{ $t('solutions.fleet.sectionBackOffice.contentBold') }}</strong>.  </div>
        <router-link class="btn btn-primary mt-3" to="/solutions/fleet"> {{ $t('more') }} </router-link>    <a target="blank" class="btn btn-secondary mt-3" href="https://fleet.agrivitech.com">{{ $t('solutions.fleet.sectionBackOffice.btnFleet') }} <strong>{{ $t('fleet') }}</strong></a>
      </div>
      <div class="col-sm-12 col-md-6 text-center order-first">
          <img  src="@/assets/img/fleet/mockmacbo.png" 
            class="img-fluid" 
            alt="Fleet App" >
      </div>
    </div>
    <div class="row solution-preview">
      <div class="col-sm-12 col-md-6 text-center order-first order-md-last">
          <img style="max-width: 300px;" src="@/assets/img/fleet/app.png" 
            class="img-fluid" 
            alt="Fleet App" >
      </div>

      <div class="col-sm-12 col-md-6 light-block">
        <div class="title-block"><strong>{{ $t('solutions.fleet.sectionDriver.title') }}</strong> <br> {{ $t('solutions.fleet.sectionDriver.subTitle') }}</div>
        <div class="mb-3"> {{ $t('solutions.fleet.sectionDriver.content') }} <br> {{ $t('solutions.fleet.sectionDriver.content2') }} <strong>{{ $t('solutions.fleet.sectionDriver.contentBold') }}</strong>.  </div>
        <div class="mb-3">{{ $t('solutions.fleet.sectionDriver.content3') }}</div>
      </div>
    </div>


    
  </div>

  
  </div>
</template>

<script>

  export default {
    name: 'Solutions',
    props: {
    },

    data() {
      return {
        showContent1: false,
        showContent2: false,
        showContent3: false,
        showContent4: false,
        
      }
    },
    created(){
      // this.$matomo && this.$matomo.trackPageView()
      // console.log(this.$matomo)
      
    },
  }

</script>

<style lang="scss" scoped>


a {
  color: var(--mainBlue);
  &:hover{
    color: var(--mainBlue);
    text-decoration: none;
  }
}

.logoClient {
  max-height: 80px;
}


.greybg{
  background-color: #f0f0f0;
  padding-bottom: 100px;
}

header {
  position: relative;
  top: 0;
  background-color: var(--mainBlue);
  height: 75vh;
  min-height: 25rem;
  width: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-image: url('../assets/img/illustrations/bgWild.jpg');
    background-position: bottom;
    background-size: cover;
    opacity: 0.5;
    z-index: 1;
  }
  .container {
    position: relative;
    z-index: 2;
    color: white;
    h1 {
      font-weight: 700;
      .green {
        color: var(--mainGreen);
      }
    }
    h2{
      font-size: 25px;
      .green {
        color: var(--mainGreen);
      }
    }
  }
}

header {
  height: auto;
  max-height: 1000px;
  background-color: var(--mainBlue);
  @media  (min-width: 601px) {
    min-height: 600px;
  }
  @media  (max-width: 600px) {
    min-height: 500px;
}



  .bannerTitle{
    color: white!important;
    font-size: 30px;
    font-weight: 600;
    z-index: 1;
    .greened{
      color: var(--mainGreen);
      font-size: 55px;
    }
  }

  .banner{
    width: 100%;
    height: auto;
    min-height: 100%;
    position: absolute;
    opacity: 0.25;
    top: 50%;
    left: 50%;
    z-index: 0;
    -ms-transform: translateX(-50%) translateY(-50%);
    -moz-transform: translateX(-50%) translateY(-50%);
    -webkit-transform: translateX(-50%) translateY(-50%);
    transform: translateX(-50%) translateY(-50%);
  }

  #carouselExampleControls{
    width: 100%;
    height: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 0;
    -ms-transform: translateX(-50%) translateY(-50%);
    -moz-transform: translateX(-50%) translateY(-50%);
    -webkit-transform: translateX(-50%) translateY(-50%);
    transform: translateX(-50%) translateY(-50%);
    @media  (max-width: 600px) {
      img{
        max-height: 50px;
      }
    }
  }

  video {
    width: 100%;
    height: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 0;
    -ms-transform: translateX(-50%) translateY(-50%);
    -moz-transform: translateX(-50%) translateY(-50%);
    -webkit-transform: translateX(-50%) translateY(-50%);
    transform: translateX(-50%) translateY(-50%);
  }
}

#videoLink{
  font-size: 60px;
  width: fit-content;
  color: white;
  opacity: 1;
  a{
    color:#FF0000;
  }
  .svg{
    background-color: white;
    border-radius: 20px;
  }
  &:hover{
    color: #FF0000;
    cursor: pointer;
    transform: scale(1.1);
  }
}

.clients-logo{
  justify-content: space-around;
}


.bannerImg{
  height: auto;
  width: 100%;
  border-radius: 20px;
  margin: 10px;
}

.title{
  text-align: center;
  font-weight: 700;
  font-size: 40px;
  color: var(--mainBlue);
  margin: 100px 0px 0px 0px;
  padding-bottom: 0;
}

.subTitled{
  padding: 40px 0px;
}
.highlighted{
  font-weight: 600;
  font-size: 25px;
  color: var(--mainGreen);
  padding: 30px 0px;
}
.solution-preview{
  margin: 50px 0px;
  line-height: 25px;
  text-align: left;
  display: flex;
  align-items: center;
}
.title-block {
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 20px;
  line-height: 40px;
  strong{
    font-size: 38px;
    font-weight: 700;
    background-color: var(--mainGreen);
    padding: 0 5px;
  }
}
.dark-block{
  min-height: 200px;
  color: white;
  background-color: var(--mainBlue);
  padding: 20px;
  border-radius: 18px;
  text-align: left;
}
a.dark-block{
  color: white;
}
.light-block{
  min-height: 200px;
  padding: 20px;
  border-radius: 18px;
  text-align: left;
}

.cardPanel{
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .cardItem{
    text-align: left;
    width: 24%;
    height: 250px;
    border-radius: 10px;
    background-color: #f9f9f9;
    overflow: hidden;
    .cardItemTitle{
      // background-color: #a4f3d7;
      color: var(--mainBlue);
      font-weight: 700;
      font-size: 16px;
      padding: 30px 15px;
    }
    .cardItemContent{
      padding: 15px;
    }
    .cardItemHiddenContent{
      display: none;
    }
    .open{
      text-align: end;
      padding-right: 20px;
      font-size: 20px;
      cursor: pointer;
      color: #A4A4A4;
      display: none;
      z-index: 1;
      &:hover{
        color: var(--mainBlue);
      }
    }
    &:hover{
      .open{
        display: block;
      }
    }
    &.active{
      background-color: #a4f3d7;
      width: 100%;
      max-width: 1140px;
      @media  (max-width: 991px){
        width: 690px;
        height: 570px;
      }
      @media  (max-width: 767px){
        max-width: 510px;
        padding-right: 40px;
        height: 570px;
      }
      @media  (max-width: 455px){
        max-width: 300px;
        height: 570px;
      }
      transition: all .5s;
      transition-property: left,width,height,top,box-shadow;
      position: absolute;
      z-index: 2;
      .open{
        display: none;
      }
      .cardItemHiddenContent{
        display: block;
        padding: 15px;
        .link{
          position: absolute;
          right: 20px;
          bottom: 20px;
          background-color: white;
          padding: 5px;
          border-radius: 5px;
          cursor: pointer;
          &:hover{
            background-color: #f9f9f9;
          }
        }
        .close{
          position: absolute;
          right: 20px;
          top: 20px;
          color: white;
          cursor: pointer;
          &:hover{
            color: #f9f9f9;
          }
        }
      }
    }
  }
  @media  (max-width: 991px) {
      .cardItem{
        width: 49%;
        margin-bottom: 10px;
        height: 280px;
      }
    }
  @media  (max-width: 455px) {
      .cardItem{
        width: 100%;
        margin-bottom: 10px;
        height: 200px;
      }
    }
}

</style>
